import { ParishProject } from './index';

export class Parish {
         id: number;
         code: string;
         name: string;
         pstreet: string;
         city: string;
         pstate: string;
         ppostalCode: string
         pphone1: string;
         centerId: number;
         regionName: string;
         centerName: string;
         promoterEmail: string;
         promoterName: string;
         phone1: string;
         parishProjects: Array<ParishProject>;
         status: string;
         createdBy: number;
         updatedBy: number;
}
